import * as z from 'zod/mini';

import { createStorageKeySchema } from '../../../services/storage';

/**
 * Dedicated storage key for the prefetched nonce pool.
 *
 * The pool must NOT live in the synced state blob: that blob is rewritten on
 * every state change from a possibly-stale in-memory copy, which resurrects
 * already-consumed single-use nonces. This key is only ever written through
 * `updateNoncePoolStorage`'s serialized read-modify-write.
 */
export const noncePoolStorageKeySchema = createStorageKeySchema({
  key: 'nonce-pool',
  schema: z.object({
    /**
     * Milliseconds since epoch when the pooled nonces expire server-side.
     */
    expiration: z.number(),
    nonces: z.array(z.string()),
  }),
});

/**
 * The persisted nonce pool shape. Exported here because it is shared by every
 * function operating on the pool's storage key.
 */
export type NoncePool = z.infer<typeof noncePoolStorageKeySchema.schema>;
